'use strict';

const { Component } = require('phy');
const { hydrate } = require('@grpn/hydration');

const { subscribe } = require('../../support/event-observer');
const groupPremiumOffers = require('../../support/group-premium-offers');

const CouponsList = require('./coupons-list');

class CouponsListFilter extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      offerType: null,
    };

    this.setOfferFilter = this.setOfferFilter.bind(this);
  }

  componentDidMount() {
    subscribe('@filter', this.setOfferFilter);
  }

  componentDidUpdate() {
    window.Groupon.Utils.lazyLoadImages();
  }

  render() {
    const { media = 'logo', routes, color, referralSource = '' } = this.props;
    const { premiumList, couponList } = this.getFilteredLists();

    return CouponsList({
      premium: premiumList,
      coupons: couponList,
      media,
      color,
      routes,
      referralSource,
    });
  }

  setOfferFilter({ offerType }) {
    this.setState({
      offerType,
    });
  }

  getFilteredLists() {
    const { coupons, showPremium = true } = this.props;
    const { offerType } = this.state;

    let { premiumList, couponList } = groupPremiumOffers(
      coupons,
      showPremium ? 1 : 0
    );

    if (offerType) {
      [premiumList, couponList] = [premiumList, couponList].map(list =>
        list.filter(coupon => coupon.offerType === offerType)
      );
    }

    return { premiumList, couponList };
  }
}

module.exports = hydrate('CouponsListFilter', CouponsListFilter);
